import React, { useRef, useState, useEffect } from "react";
import "./sign_in.css";
import { BASE_URL } from "../../constants/Constants";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { Button, Form } from "react-bootstrap";

function SignIn() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const emailRef = useRef(null);
  const passwordRef = useRef(null);

  useEffect(() => {
    if (error) {
      const timer = setTimeout(() => setError(""), 2000); // Clears the error after 2 seconds
      return () => clearTimeout(timer); // Cleanup to prevent memory leaks
    }
  }, [error]);

  const onSubmit = async (event) => {
    event.preventDefault();
    const username = emailRef.current.value;
    const password = passwordRef.current.value;

    if (!username || !password) {
      setError(" يرجى ملئ جميع الحقول");
      return;
    }
    console.log(process.env.REACT_APP_API_URL);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/staff/login/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ username, password }),
        }
      );

      if (!response.ok) {
        const data = await response.json();

        setError(
          data.detail || " لا يمكنك تسجيل الدخول؟ يمكنك إستخدام تحقق مختلف"
        );
        return;
      }

      const data = await response.json(); // Extract the JSON data
      const tok = data.token; // Assuming your backend sends the token in a `token` field
      if (!tok) {
        setError("🔑 رمز غير صحيح. برجاء التواصل مع الدعم");
        return;
      }

      // Perform login action
      const newData = {
        token: tok,
        username: data.username,
        email: data.email,
        is_staff: data.is_staff,
        image: data.image,
      };
      login(newData);
      navigate("/");
    } catch (err) {
      console.error("Login Error:", err);
      setError(" حدث شئ خطأ، برجاء المحاولة لاحقًا");
    }
  };

  return (
    <div className="main-login">
      <div className="screen">
        <div className="screen__content">
          <Form className="login" onSubmit={onSubmit}>
            <Form.Group
              className="mb-3 login__field"
              controlId="formBasicEmail"
            >
              <Form.Control
                ref={emailRef}
                type="email"
                placeholder="إسم المستخدم"
                className="login__input"
              />
            </Form.Group>

            <Form.Group
              className="mb-3 login__field"
              controlId="formBasicPassword"
            >
              <Form.Control
                ref={passwordRef}
                type="password"
                placeholder="كلمة المرور"
                className="login__input"
              />
            </Form.Group>

            <Button
              variant="primary"
              type="submit"
              className="button login__submit"
            >
              تسجيل الدخول
            </Button>
          </Form>
          {error && <div className="error-message">{error}</div>}
          <div className="social-login">
            <div className="social-icons">
              {/* Add social icons here if needed */}
            </div>
          </div>
        </div>
        <div className="screen__background">
          <span className="screen__background__shape screen__background__shape4"></span>
          <span className="screen__background__shape screen__background__shape3"></span>
          <span className="screen__background__shape screen__background__shape2"></span>
          <span className="screen__background__shape screen__background__shape1"></span>
        </div>
      </div>
    </div>
  );
}

export default SignIn;
